export default __webpack_public_path__ + "app/src/scenes/study-page/create-study/cohort-selection/cohortapp-icon.svg";